import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { ToastBridge } from './components/ToastBridge';
import { ToastProvider } from './components/ui';
import { CACHE_BUSTER, persistOptions, queryClient } from './query/queryClient';
import { router } from './routes';
import { ServiceProvider } from './services/ServiceContext';

export function App() {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ ...persistOptions, buster: CACHE_BUSTER }}
    >
      <AuthProvider>
        <ServiceProvider>
          {/* Outside the router, so a toast raised by a write survives the
              navigation that write may cause. */}
          <ToastProvider>
            <ToastBridge />
            <RouterProvider router={router} />
          </ToastProvider>
        </ServiceProvider>
      </AuthProvider>
    </PersistQueryClientProvider>
  );
}
